import React, { useState, useEffect } from "react";
import TabelaPlanejamentoTotal from "../../../components/TabelaPlanejamentoTotal";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { MdOutlineArrowBack } from "react-icons/md";
import PageContainer from "../../../components/PageContainer";
import { Tabs, Tab, Button } from "react-bootstrap";
import RelatorioApiService from "../../../services/api/RelatorioApiService";
import Loading from "../../../components/Loading";
import UtilService from "../../../services/util";

const FluxoCaixaView = () => {
    // Define a aba ativa
    const [abaAtiva, setAbaAtiva] = useState("planejados");
    // Define os projetos planejados e realizados
    const [dadosPlanejados, setDadosPlanejados] = useState({});
    const [dadosReais, setDadosReais] = useState({});
    // Define os projetos planejados e realizados abertos ou fechados
    const [openProjetosPlanejado, setOpenProjetosPlanejado] = useState({});
    const [openProjetosRealizado, setOpenProjetosRealizado] = useState({});
    // Define o estado de carregamento
    const [loading, setLoading] = useState(false);

    // Pega os dados do filtro (state)
    const { data } = useLocation().state;

    useEffect(() => {
        const fetchDadosRelatorio = async () => {
            setLoading(true);
            try {
                const { projetosSelecionados, periodoInicial, periodoFinal } = data;

                // Pega o dia, mês e ano da data inicial e final
                const [diaInicial, mesInicial, anoInicial] = periodoInicial.split('/');
                const [diaFinal, mesFinal, anoFinal] = periodoFinal.split('/');

                // Define os meses em inglês
                const mesesEmPortugues = {
                    '01': 'Jan',
                    '02': 'Feb',
                    '03': 'Mar',
                    '04': 'Apr',
                    '05': 'May',
                    '06': 'Jun',
                    '07': 'Jul',
                    '08': 'Aug',
                    '09': 'Sep',
                    '10': 'Oct',
                    '11': 'Nov',
                    '12': 'Dec'
                };

                // Formata a data inicial e final para o formato dd/MMM/yyyy
                const dataInicialFormatada = `${diaInicial}-${mesesEmPortugues[mesInicial]}-${anoInicial}`;
                const dataFinalFormatada = `${diaFinal}-${mesesEmPortugues[mesFinal]}-${anoFinal}`;

                // Montar a URL dinâmica com todos os projetos no novo formato
                const nomesProjetos = projetosSelecionados.map(p => p.value).join(',');
                const nomesIdsProjetos = projetosSelecionados.map(p => `${p.value}-${p.id}`).join(',');
                const urlProjetos = `/${nomesProjetos}/${nomesIdsProjetos}`;

                // Chamada única do endpoint
                const response = await RelatorioApiService.getFluxoCaixa(
                    urlProjetos,
                    dataInicialFormatada,
                    dataFinalFormatada,
                    true // se precisar de algum parâmetro extra, ajuste aqui
                );

                // Define os dados planejados e realizados
                setDadosPlanejados(response.data?.dadosPlanejados || {});
                setDadosReais(response.data?.dadosReais || {});

                // Inicializa todos abertos
                const projetosPlanejados = Object.keys(response.data?.dadosPlanejados || {});
                const projetosReais = Object.keys(response.data?.dadosReais || {});
                setOpenProjetosPlanejado(Object.fromEntries(projetosPlanejados.map(p => [p, true])));
                setOpenProjetosRealizado(Object.fromEntries(projetosReais.map(p => [p, true])));
            } catch (error) {
                console.error('Erro ao buscar dados do relatório:', error);
            } finally {
                setLoading(false);
            }
        };

        // Se os dados do filtro existem, busca os dados do relatório
        if (data) {
            fetchDadosRelatorio();
        }
    }, [data]);

    // Função para exportar dados em Excel
    const exportDataInExcel = () => {
        const header = [
            ['Projeto', 'Tipo', 'Mês/Ano', 'Valor de Venda', 'Custo Total Função', 'Custo Total Indireto', 'Custo Total Geral', 'Margem']
        ];

        const formattedData = [];

        // Função auxiliar para formatar dados de um tipo (planejado/real)
        const formatarDadosTipo = (dados, tipo) => {
            Object.keys(dados).forEach(projeto => {
                Object.keys(dados[projeto]).forEach(mesAno => {
                    const dadosMes = dados[projeto][mesAno];
                    const valorVenda = parseFloat(dadosMes.valorVenda) || 0;
                    const custoFuncao = parseFloat(dadosMes.total_previsto_funcao?.soma_custo_total_funcao) || 0;
                    const custoIndireto = parseFloat(dadosMes.total_previsto_indireto) || 0;
                    const custoTotalGeral = custoFuncao + custoIndireto;
                    const margem = valorVenda - custoTotalGeral;

                    formattedData.push({
                        projeto,
                        tipo,
                        mesAno,
                        valorVenda: valorVenda.toFixed(2),
                        custoTotalFuncao: custoFuncao.toFixed(2),
                        custoTotalIndireto: custoIndireto.toFixed(2),
                        custoTotalGeral: custoTotalGeral.toFixed(2),
                        margem: margem.toFixed(2)
                    });
                });
            });
        };

        // Formatar dados planejados
        formatarDadosTipo(dadosPlanejados, 'Planejado');
        
        // Formatar dados realizados  
        formatarDadosTipo(dadosReais, 'Realizado');

        const nomeArquivo = `Fluxo de Caixa - ${data.periodoInicial} a ${data.periodoFinal}`;
        UtilService.exportXls(formattedData, nomeArquivo, header);
    };

    const actions = [
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: useHistory().goBack
        }
    ]

    // Função para abrir e fechar os projetos planejados
    const toggleCostsPlanejado = (projeto) => {
        setOpenProjetosPlanejado(prev => ({ ...prev, [projeto]: !prev[projeto] }));
    };

    // Função para abrir e fechar os projetos realizados
    const toggleCostsRealizado = (projeto) => {
        setOpenProjetosRealizado(prev => ({ ...prev, [projeto]: !prev[projeto] }));
    };

    // Verifica se há dados planejados ou realizados
    const temDadosPlanejados = Object.keys(dadosPlanejados).length > 0 && 
        Object.values(dadosPlanejados).some(projeto => Object.keys(projeto).length > 0);
    const temDadosRealizados = Object.keys(dadosReais).length > 0 && 
        Object.values(dadosReais).some(projeto => Object.keys(projeto).length > 0);

    return (
        <PageContainer title="Fluxo de Caixa" actions={actions}>
            <div className="container-fluid">
{/*                 {(temDadosPlanejados || temDadosRealizados) && !loading && (
                    <Button onClick={exportDataInExcel} className='mb-3'>Exportar</Button>
                )} */}
                <Tabs activeKey={abaAtiva} onSelect={(k) => setAbaAtiva(k)} className="mb-4">
                    <Tab eventKey="planejados" title="Planejado na venda" style={{maxWidth: "calc(-270px + 100vw)"}}>
                        {loading ? (
                            <Loading message={"Carregando..."} />
                        ) : temDadosPlanejados ? (
                            Object.keys(dadosPlanejados).map((projeto) => (
                                <div className="table table-bordered table-content p-3" key={projeto}>
                                    <h3 onClick={() => toggleCostsPlanejado(projeto)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                        <span className='mr-2'>{projeto}</span>
                                        {openProjetosPlanejado[projeto] ? '▴' : '▾'}
                                    </h3>
                                    {openProjetosPlanejado[projeto] && (
                                        <div className="mr-3 ml-3">
                                            <TabelaPlanejamentoTotal dadosPlanejamento={{meses: dadosPlanejados?.[projeto]}} tipo="planejado" />
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="text-center p-5">
                                <p className="text-muted">Não há dados planejados para o período selecionado</p>
                            </div>
                        )}
                    </Tab>
                    <Tab eventKey="realizados" title="Realizados" style={{maxWidth: "calc(-270px + 100vw)"}}>
                        {loading ? (
                            <Loading message={"Carregando..."} />
                        ) : temDadosRealizados ? (
                            Object.keys(dadosReais).map((projeto) => (
                                <div className="table table-bordered table-content p-3" key={projeto}>
                                    <h3 onClick={() => toggleCostsRealizado(projeto)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                        <span className='mr-2'>{projeto}</span>
                                        {openProjetosRealizado[projeto] ? '▴' : '▾'}
                                    </h3>
                                    {openProjetosRealizado[projeto] && (
                                        <div className="mr-3 ml-3">
                                            <TabelaPlanejamentoTotal dadosPlanejamento={{meses: dadosReais?.[projeto]}} tipo="real" />
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="text-center p-5">
                                <p className="text-muted">Não há dados realizados para o período selecionado</p>
                            </div>
                        )}
                    </Tab>
                </Tabs>
            </div>
        </PageContainer>
    );
};

export default FluxoCaixaView;